import { gql } from '@apollo/client';

import { NIGHTLY_COUNT_FRAGMENT } from '../queries';

export const SAVE_NIGHTLY_COUNT_MUTATION = gql`
  mutation saveNightlyCount($input: SaveNightlyCountInput!) {
    saveNightlyCount(input: $input) {
      ...NightlyCount
    }
  }
  ${NIGHTLY_COUNT_FRAGMENT}
`;

export const DELETE_NIGHTLY_COUNT_MUTATION = gql`
  mutation deleteNightlyCount($input: NightlyCountIdInput!) {
    deleteNightlyCount(input: $input)
  }
`;

export const RESEND_NIGHTLY_COUNT_MUTATION = gql`
  mutation resendNightlyCount($input: NightlyCountIdInput!) {
    resendNightlyCount(input: $input)
  }
`;
